import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import PartnerDetail from './Detail';
import PartnerTeaser from './Teaser';

interface NodePartnerProps {
  entity: ImmutableEntity<any>;
  className?: string;
  viewMode?: string;
}

const NodePartner: React.FC<NodePartnerProps> = ({ entity, className, viewMode }) => {
  switch (viewMode) {
    case 'teaser':
      return <PartnerTeaser entity={entity} className={className} />;
    default:
      return <PartnerDetail entity={entity} />;
  }
};

export default NodePartner;
